// import Home from "./pages/Home";
import "./App.css";
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Team from "./pages/Team";
import TeamMember from "./components/Team/TeamMember";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Error from "./pages/Error";
import Loader from "./components/Loader";
import FAQ from "./pages/FAQs";
import Trainings from "./pages/Trainings";
import Consultancy from "./pages/Consultancy";
import Blogs from "./pages/Blogs";
import BlogPost from "./pages/BlogPost";
import Career from "./pages/Career";
import BidWriting from "./pages/BidWriting";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => setLoading(false);

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load", handleLoad);
    }
  }, []);

  return (
    <div className="App">
      {loading ? (
        <Loader />
      ) : (
        <Router>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/team" element={<Team />} />
            <Route exact path="/team/:id" element={<TeamMember />} />
            <Route exact path="/trainings" element={<Trainings />} />
            <Route exact path="/bid-writing" element={<BidWriting />} />
            <Route exact path="/consultancy" element={<Consultancy />} />
            <Route exact path="/about-us" element={<AboutUs />} />
            <Route exact path="/contact-us" element={<ContactUs />} />
            <Route exact path="/faqs" element={<FAQ />} />
            <Route exact path="/career" element={<Career />} />
            <Route exact path="/blogs" element={<Blogs />} />
            <Route exact path="/blogs/:id" element={<BlogPost />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </Router>
      )}
    </div>
  );
}

export default App;
